import { getLargeWorldCollisionCandidatesAt, type StaticCollider } from "@endclock/shared";
import { createCameraCollisionProbe } from "../engine/camera-collision.js";
import type { CameraCollisionProbe } from "../engine/camera.js";

/** Static world proxies are immutable. A small cell cache covers long aim rays without mesh queries. */
export function createWorldAimProbe(heightAt: (x: number, z: number) => number): CameraCollisionProbe {
  const cells = new Map<string, readonly StaticCollider[]>();
  let current: readonly StaticCollider[] = [];
  const probe = createCameraCollisionProbe(heightAt, () => current);
  return (x, y, z, radius) => {
    const cellX = Math.floor(x / 16);
    const cellZ = Math.floor(z / 16);
    const key = `${cellX}:${cellZ}`;
    let colliders = cells.get(key);
    if (!colliders) {
      colliders = getLargeWorldCollisionCandidatesAt(cellX * 16 + 8, cellZ * 16 + 8, 16);
      if (cells.size >= 64) cells.delete(cells.keys().next().value!);
      cells.set(key, colliders);
    }
    current = colliders;
    return probe(x, y, z, radius);
  };
}
